export const COOKIE_USER = 'SEVANEST_ADMIN_USER';
export const COOKIE_TOKEN = 'SEVANEST_ADMIN_TOKEN';
